import { render, staticRenderFns } from "./AszfModal.vue?vue&type=template&id=f5861986&scoped=true&"
import script from "./AszfModal.vue?vue&type=script&lang=js&"
export * from "./AszfModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5861986",
  null
  
)

export default component.exports